





























import { Component, Watch } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import DepositFixedTermMaturitySettingsEdit from '@/components/Products/Forms/Deposit/DepositFixedTermMaturitySettingsEdit.vue';
import { ProductDetailsModule } from '@/store/Products/ProductDetailsModule';

@Component({ name: 'DepositFixedTermMaturitySettingsEditDialog', components: { DepositFixedTermMaturitySettingsEdit } })
export default class extends SaascadaVueDialog {

    @Watch('dialog')
    async onDialogChanged(val: boolean, oldVal: boolean) {
        if (val) {
            ProductDetailsModule.prepareProductViewModel();
        }
    }

    async save() {
        if (!(this.$refs.form as any).validateForm()) {
            return;
        }
        else {
            this.dialog = false;
            await ProductDetailsModule.editDepositFixedTermMaturitySettings();
            await ProductDetailsModule.getHistory();
        }
    }

}
